<!--
 * @Author: 汪俊洪
 * @Date: 2021-10-09 10:47:30
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2024-02-27 18:48:51
 * @Description: 销售发票申请详情
-->
<template>
  <div class="wrap">
    <div class="order-info">
      <span class="status">
        发票申请单
      </span>
      <span class="orderSource">{{ detail.invoiceApplyStatusText }}</span>
      <span class="days">（{{ detail.days }}）</span>
    </div>
    <el-descriptions class="descriptions" :colon="false" title="" >
      <el-descriptions-item label="单据编号：" :span="3">
        <Copyable class="copyable" :text="detail.invoiceApplyNo"></Copyable>
      </el-descriptions-item>
      <el-descriptions-item label="创建时间：">
        {{ detail.createTime || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="申请人：">
        {{ detail.createUserName || '-' }}
      </el-descriptions-item>
      <el-descriptions-item
        v-if="detail.invoiceApplyStatus === '6'"
        label="关闭原因："
      >
        {{ detail.cancelRemark || '-' }}
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
import Copyable from '@/components/copyable/index.vue'
export default {
  props: {
    detail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components: {
    Copyable
  }
}
</script>

<style lang="scss" scoped>
.order-info {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #303133;
  .orderSource {
    padding: 0 5px;
    line-height: 24px;
    font-size: 14px;
    color: rgb(26, 188, 156);
    border: 1px solid rgb(26, 188, 156);
    border-radius: 4px;
  }
  .status {
    font-size: 14px;
    font-weight: 700;
    padding-right: 12px;
  }
}
.copyable {
  margin: 0 0 -2px 4px;
}
.descriptions {
  width: 800px;
  margin-top: 4px;
  ::v-deep .el-descriptions-item__cell {
    padding-bottom: 4px;
  }
}
</style>
